module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./~/_babel-runtime@6.22.0@babel-runtime/regenerator/index.js
// module id = 445
// module chunks = 0